import { ProductItem, ProductItemForCharge } from '../types';
import { GroupType } from 'graphql-query-contracts';

export function productItemsToQueryFormat(
  productItems: ProductItem[]
): ProductItemForCharge[] {
  return productItems.map(productItem => {
    const product = productItem.product;

    const sellingPrice = product.sellingPrice ? {
      grossTax: product.sellingPrice.grossTax,
      grossMarkup: product.sellingPrice.grossMarkup,
      listPrice: product.sellingPrice.listPrice,
      netPrice: product.sellingPrice.netPrice,
      grossAdminFee: product.sellingPrice.grossAdminFee ?? 0,
    } : undefined;

    return {
      product: {
        id: product.id,
        name: product.name,
        description: product.description,
        amount: Math.max(0, Number(product.amount)),
        groupId: product.groupId,
        groupType: GroupType.GroupTypeActivateChannel,
        markup: {
          value: Number(product.markup?.value),
          markupAmountType: product.markup?.markupAmountType!,
        },
        tax: {
          value: Number(product.tax?.value),
          taxAmountType: product.tax?.taxAmountType!,
        },
        originalPrice: product.originalPrice
          ? {
              amount: product.originalPrice.amount,
              markup: {
                value: product.originalPrice.markup?.value || 0,
                markupAmountType: product.originalPrice.markup
                  ?.markupAmountType!,
              },
              tax: {
                value: product.originalPrice.tax?.value || 0,
                taxAmountType: product.originalPrice.tax?.taxAmountType!,
              },
            }
          : undefined,
        sellingPrice,
      },
      quantity: productItem.quantity,
      productCategoryId: productItem.product.productCategory.productCategoryId,
      chargeCodeId: productItem.product.chargeCode?.id!,
      isRateOverridden: productItem.isRateOverridden,
    };
  });
}
